(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("KarcherAlarmsController", KarcherAlarmsController);

  /** @ngInject */
  function KarcherAlarmsController(
    $scope,
    KarcherAlarmsViewModel,
    dashboardKarcherActions,
    organizationActions,
    layoutActions,
    $timeout,
    $state,
    exportToCsv,
    $translate,
    fromArrayToPathParam,
    alarmsStore
  ) {
    var vm = this;
    var facilityId = "";

    vm.exportToCsvSiteList = exportCsv;
    vm.alarmMessages = new KarcherAlarmsViewModel();
    vm.alarmPageTitle = $translate.instant("ALERT_CENTER_TITLE_BY_DEFAULT");

    vm.pageChanged = function (page, limit) {
      vm.alarmMessages.alarmsPaginationChanged(page, limit);
      refresh();
    };

    vm.sortChanged = function (order) {
      vm.alarmMessages.alarmsOrderingChanged(order);
      refresh();
    };

    vm.searchMessages = function (siteIds) {
      layoutActions.showLoader();
      facilityId = "";
      vm.alarmPageTitle = $translate.instant("ALERT_CENTER_TITLE_BY_DEFAULT");
      vm.alarmMessages.alarmsPage = 1;
      if (siteIds !== undefined && siteIds !== null) {
        vm.alarmMessages.selectedSite = siteIds;
      }
      refresh();
    };

    vm.subscriptions = function () {
      $state.go("app.alarms.subscriptions");
    };

    vm.clearSiteInput = function () {
      vm.alarmMessages.selectedSite = "";
      refresh();
    };

    init();

    function init() {
      layoutActions.showLoader();
      $scope.$on("$destroy", destroy);
      organizationActions.getAllSitesForExactUser().then(function (res) {
        vm.alarmMessages.refreshSiteList(res);
        if (alarmsStore.getAlarmsParams()) {
          vm.alarmPageTitle = $translate.instant("ALERT_CENTER_TITLE_BY_DEFAULT");
          vm.alarmPageTitle = setReportTitle(
            alarmsStore.getAlarmsParams()
          );
          vm.alarmMessages.selectedSite = alarmsStore.getAlarmsParams().site;
          facilityId = alarmsStore.getAlarmsParams().facility;
          vm.alarmMessages.alarmsFrom = new Date(
            alarmsStore.getAlarmsParams().from
          );
          vm.alarmMessages.faultStatus =
            alarmsStore.getAlarmsParams().faultStatus;
        }
        refresh();
      });
    }

    function exportCsv() {
      var exportData = prepareDataForCsvDownload(vm.alarmMessages.alarmsData);
      exportToCsv.export(exportData, $translate.instant("ALERTS"), true);
    }

    function setReportTitle(type) {
      switch (true) {
        case type.site !== "":
          return $translate.instant("ALERT_CENTER_TITLE_BY_SITE");
        case type.facility !== "":
          return $translate.instant("ALERT_CENTER_TITLE_BY_FACILITY");
        default:
          return $translate.instant("ALERT_CENTER_TITLE_BY_DEFAULT");
      }
    }

    function prepareDataForCsvDownload(data) {
      var tempArray = [];
      data.forEach(function (item) {
        tempArray.push({
          Code: item.karcherFault.number,
          Date: item.timestamp,
          Company_name: item.companyName,
          Facility_name: item.washFacilityName,
          Alert_name: item.karcherFault.name,
          Alert_description: item.karcherFault.description,
          Type: item.karcherFault.washFacilityStatus,
          Status: item.status
            ? $translate.instant("RESOLVED_STATUS")
            : $translate.instant("NOT_RESOLVED_STATUS")
        });
      });
      return tempArray;
    }

    function refresh() {
      dashboardKarcherActions
        .getKarcherSiteAlarmList(
          vm.alarmMessages.filterBy,
          vm.alarmMessages.faultStatus,
          facilityId,
          fromArrayToPathParam.createPath(
            vm.alarmMessages.selectedSite,
            "sitePointId="
          ),
          vm.alarmMessages.alarmsFrom.getTime(),
          vm.alarmMessages.alarmsTo.getTime(),
          vm.alarmMessages.alarmsPage - 1,
          vm.alarmMessages.alarmsPageSize,
          vm.alarmMessages.alarmsOrderBy,
          vm.alarmMessages.alarmsOrder
        )
        .then(function (response) {
          vm.alarmMessages.refreshMessages(response);
          layoutActions.hideLoader();
        });
    }

    function destroy() {
      alarmsStore.deleteStore();
    }
  }
})();
